import { UsersFilter } from '../models';
import { useGetUsersQuery } from '../services/users.service';

interface UseUserProps {
  filters?: UsersFilter;
  search?: string;
  paginated: {
    page: number;
    pageSize: number;
  };
}

const useUsers = ({ filters,  paginated }: UseUserProps) => {
  const {
    data: users,
    isLoading: isUsersLoading,
    error,

  } = useGetUsersQuery({ filters,  paginated });

  return {
    users: users?.items || [],
    totalItems: users?.count || [].length,
    totalPages: users?.count ? Math.ceil(users.count / paginated.pageSize) : 0,
    isUsersLoading,
    error,
  };
};

export default useUsers;
